export default __webpack_public_path__ + "private/foundation/images/587fd69d84ae8ae15f54c621cc883bde.svg";